import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedataService } from '../../../../helpers/service/sharedata.service';

@Component({
  selector: 'app-navbar-dark',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="container">
      <nav class=" mt-10">
        <ul class="grid grid-cols-12 gap-4" style="width: 100%;" >
          <li>
            <a href="">
              <img src="../../../../../assets/dark/iconnav.png" width="50" height="50" alt="">
            </a>
          </li>
          <li class="mt-3 col-span-2">
            <a href="">
              <!-- <img src="../../../../../assets/dark/iconnamenav.png" width="50" height="50" alt=""> -->
              <span class="agadevin">
                AGADIDEVIN
              </span>
            </a>
          </li>
          <li class="mt-3">
            <a (click)="scrollTo('about')">
             ABOUT
            </a>
          </li>
          <li class="mt-3">
            <a href="">
             SERVICES
            </a>
          </li>
          <li class="mt-3">
            <a href="">
             TECHNOLOGY
            </a>
          </li>
          <li style="margin-left:40px;" class="mt-3 col-span-2 ">
            <a href="">
             HOW TO
            </a>
          </li>
          <li class="mt-2 col-span-1">
           <button class="btn btn-outline-primary w-32" style="border-radius: 20px; border-color:white; color:white; height:48px; font-size:12px;">CONTACT USE</button>
          </li>
          <li class="mt-2" style="margin-left:40px;">
           <button class="ml-4 btn btn-outline-primary w-52" style="border-radius: 20px; height:48px; font-size:12px; background:linear-gradient(#8176AF,#C0B7E8); border-color:transparent; color:white;">JOIN MEMBER</button>
          </li>
        </ul>
      </nav>
    </div>
  `,
  styleUrls: ['navbar.components.scss'],
})
export class NavbarDarkComponent implements OnInit {
  @Output() linkScroll = new EventEmitter<any>();
  constructor(private shareServiceData: SharedataService) { }

  ngOnInit(): void {
  }
  scrollTo(nameNav: string){
    this.shareServiceData.doShareNaveName(nameNav)
    console.log(nameNav, 'ini navbar')
  }

}
